import React from "react";

function Admin() {
  return <h1 className="text-center mt-3 mb-3">Admin Dashboard</h1>;
}

export default Admin;
